import React from 'react'
import { DisplayText } from '@paypalcorp/pp-react'
import * as styles from './collectedAmount.css'

interface CollectedAmountProps {
  children: string
}

const CollectedAmount = ({ children }: CollectedAmountProps) => {
  return (
    <DisplayText
      className={styles.amount}
      size="sm"
      type="strong"
      data-testid="groupCurrentAmount"
      as="p"
    >
      {children}
    </DisplayText>
  )
}

export default CollectedAmount
